import React from "react";
import { makeStyles } from "@material-ui/styles";
import { CircularProgress } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
  },
  logo: { width: "auto", height: "5rem" },
  fabProgress: {
    position: "absolute",
    top: -10,
    left: -10,
    zIndex: 1,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
}));

const Loading = () => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <img
          alt="logo"
          src={require("../../images/LOGO/logo3.png")}
          className={classes.logo}
        />
        <CircularProgress size={100} className={classes.fabProgress} />
      </div>
    </div>
  );
};

export default Loading;
